import { MARQUEE } from "@/lib/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display px-8 text-3xl italic text-[#221e1b]/80 sm:text-5xl">{w}</span>
        <span className="h-1.5 w-1.5 rounded-full bg-[#a8792a]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="overflow-hidden border-y border-[#e4dacb] py-8" data-testid="marquee" aria-hidden="true">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
